import { render, staticRenderFns } from "./relation.vue?vue&type=template&id=a4cc1c24&scoped=true"
import script from "./relation.vue?vue&type=script&lang=js"
export * from "./relation.vue?vue&type=script&lang=js"
import style0 from "./relation.vue?vue&type=style&index=0&id=a4cc1c24&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cc1c24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4cc1c24')) {
      api.createRecord('a4cc1c24', component.options)
    } else {
      api.reload('a4cc1c24', component.options)
    }
    module.hot.accept("./relation.vue?vue&type=template&id=a4cc1c24&scoped=true", function () {
      api.rerender('a4cc1c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/budget/finelines/form/relation.vue"
export default component.exports